import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './SidebarBackButton.css';

export default function SidebarBackButton() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  if (pathname === '/dashboard') return null;

  const alwaysHome = pathname.startsWith('/deck/') || pathname.startsWith('/upload');

  const handleClick = () => {
    if (alwaysHome) {
      navigate('/dashboard');
      return;
    }

    const historyIndex = window.history.state?.idx;
    const canGoBack =
      typeof historyIndex === 'number'
        ? historyIndex > 0
        : window.history.length > 1;

    if (canGoBack) {
      navigate(-1);
      return;
    }
    navigate('/dashboard');
  };

  return (
    <button
      type="button"
      className="sidebar-back-btn"
      onClick={handleClick}
      aria-label="Go back"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M15 18l-6-6 6-6" />
      </svg>
    </button>
  );
}
